module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue2.cc3483ae.jpg";